<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'accept'">Duyệt vé điện tử</span>
        <span v-if="mData.viewMode == 'detail'">Chi tiết vé điện tử chờ duyệt</span>
        <span v-if="mData.viewMode == 'update'">Cập nhật vé điện tử chờ duyệt</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="10">
              <b-row>
                <b-col md="5">
                  <el-form-item label="Tên dịch vụ" prop="dich_vu.ve_dien_tu.ten">
                    <el-input v-model="mData.dataForm.dich_vu.ve_dien_tu.ten"
                      :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'" clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="5">
                  <el-form-item label="Website 1ve" prop="dich_vu.ve_dien_tu.url">
                    <el-input v-model="mData.dataForm.dich_vu.ve_dien_tu.url"
                      :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'" clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="2">
                  <el-form-item label="Ngôn ngữ" prop="dich_vu.ngon_ngu">
                    <el-select v-model="mData.dataForm.dich_vu.ngon_ngu" :placeholder="aLang.c_select"
                      :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'" clearable filterable>
                      <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <label class="el-form-item__label">Trạng thái:</label> <span
                    style="font-size: 14px; padding: 0.4em 0.4em;" class="badge badge-pill ml-2"
                    :class="{ 'badge-secondary': getStatusName == 'Từ chối', 'badge-primary': getStatusName == 'Chờ duyệt', 'badge-info': getStatusName == 'Đang soạn thảo', }">{{
                      getStatusName
                    }}</span>
                </b-col>
                <b-col md="9" v-if="mData.dataForm.dich_vu.ly_do_tu_choi">
                  <el-form-item label="Lý do từ chối" prop="dich_vu.ly_do_tu_choi">
                    <el-input v-model="mData.dataForm.dich_vu.ly_do_tu_choi" type="textarea" :rows="3" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <el-form-item label="Loại hình" prop="don_vi_cung_cap.ve_dien_tu.loai">
                    <el-select v-model="mData.dataForm.don_vi_cung_cap.ve_dien_tu.loai" :placeholder="aLang.c_select"
                      disabled clearable filterable>
                      <el-option v-for="item in mData.dataDefault.listLoaiHinh" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Tên đơn vị" prop="don_vi_cung_cap.du_lieu_khai_bao.user_ten">
                    <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_ten" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="5">
                  <el-form-item label="Địa chỉ" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi">
                    <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3">
                  <el-form-item label="Số điện thoại" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai">
                    <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Email" prop="don_vi_cung_cap.du_lieu_khai_bao.email">
                    <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.email" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Website đơn vị cung cấp" prop="don_vi_cung_cap.du_lieu_khai_bao.website">
                    <el-input v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.website" disabled
                      clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Nơi đến" prop="don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id">
                    <el-select v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id"
                      :placeholder="aLang.c_select" disabled clearable filterable>
                      <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="dich_vu.ve_dien_tu.anh_hien_thi">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="danger" plain @click="fn_submitForm('not-accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.dich_vu.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Từ chối</el-button>

            <el-button type="success" plain @click="fn_submitForm('accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.dich_vu.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Duyệt</el-button>
            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">Cập
              nhật</el-button>

            <el-button type="info" plain @click="fn_submitForm('send')" v-ladda v-if="
              mData.viewMode == 'update' && mData.currentUser.roles.includes('SafePlace')
            ">Gửi</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <ModalReson :isShow="modal.showResonUpdateModal" :dataObject="mData.dataForm.dich_vu" />
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import DataService from '@/service/DataService';
import MethodService from '../../../service/MethodService';
import VeDienTuModel from './VeDienTuModel';
import ShareDonViCungCapModel from '@/views/admin/ShareModel/ShareDonViCungCapModel';
import ShareDichVuModel from '@/views/admin/ShareModel/ShareDichVuModel';
import ShareDDATModel from '@/views/admin/ShareModel/ShareDDATModel';
import ExtensionService from '@/service/ExtensionService';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import DichVuChoDuyetApi from '@/moduleApi/DichVuChoDuyetApi';
import ProvinceApi from '@/moduleApi/ProvinceApi';
import ModalReson from '@/views/admin/VuiChoiGiaiTri/ModalReson';

export default {
  components: {
    // CknoimgComponent,
    ModalReson
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "accept",
        moduleName: "VeDienTu",
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listLoaiHinh: [
            {
              value: "air_plain_ticket",
              label: 'Vé máy bay'
            },
            {
              value: "show_ticket",
              label: 'Vé nghệ thuật biểu diễn'
            },
            {
              value: "transport_ticket",
              label: 'Vé giao thông'
            }
          ],
        },
        dataForm: {
          diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
          don_vi_cung_cap: MethodService.copyObject(ShareDonViCungCapModel.dataForm),
          dich_vu: MethodService.copyObject(ShareDichVuModel.dataForm)
        },
        fileUploadOption: MethodService.copyObject(
          VeDienTuModel.dataFormOther.fileUploadOption
        ),
        validForm: VeDienTuModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
      },
      modal: {
        showResonUpdateModal: false
      },
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.id, label: item.name }
      });
    }
  },
  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-accept"
    ) {
      this.mData.viewMode = "accept";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail-history"
    ) {
      this.mData.viewMode = "detail";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update-history"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
  },
  methods: {
    async fn_submitForm(type) {
      if (type === "not-accept") {
        this.$confirm("Xác nhận từ chối dịch vụ này?", {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.modal.showResonUpdateModal = true;
          })
          .finally(() => {
            MethodService.stopLadda();
          });
      } else {
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            let data = MethodService.copyObject(this.mData.dataForm.dich_vu);
            if (type === "accept") {
              data.duyet = {
                duoc_duyet: true
              }
              await DichVuChoDuyetApi.approvedDichVu(data);
              this.fn_go();
            }
            if (type === "update") {
              if (
                this.mData.currentUser.roles.includes('Admin') ||
                this.mData.currentUser.roles.includes('Officer')
              ) {
                data.id = this.$router.currentRoute.params.id;
                data.duyet = {
                  duoc_duyet: null
                };
                await DichVuChoDuyetApi.update(data);
                this.fn_go();
              } else if (this.mData.currentUser.roles.includes('SafePlace')) {
                data.id = this.$router.currentRoute.params.id;
                data.duyet = {
                  duoc_duyet: null
                };
                data.ready = false;
                await DichVuChoDuyetApi.safePlaceUpdate(data);
                this.$router.push({
                  name: "Admin-" + this.mData.moduleName + "-history"
                });
              }
              this.$store.commit("fn_countVeDienTu");
            }
            if (type === "send") {
              data.id = this.$router.currentRoute.params.id;
              data.ready = true;
              data.duyet = {
                duoc_duyet: null
              };
              await DichVuChoDuyetApi.updateSend(data);
              this.$router.push({
                name: "Admin-" + this.mData.moduleName + "-history"
              });
              this.$store.commit("fn_countVeDienTu");
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        VeDienTuModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let dichVuChoDuyetRes = await DichVuChoDuyetApi.findById(id);
      if (dichVuChoDuyetRes.result) {
        this.mData.dataForm.dich_vu = dichVuChoDuyetRes.result;
        const donViCungCapRes = await DonViCungCapApi.findById(dichVuChoDuyetRes.result.diem_den_an_toan_id);
        this.mData.dataForm.don_vi_cung_cap = donViCungCapRes.result;
        if (dichVuChoDuyetRes.result.ve_dien_tu.anh_hien_thi) {
          let data = {
            id: dichVuChoDuyetRes.result.ve_dien_tu.anh_hien_thi,
            name: dichVuChoDuyetRes.result.ve_dien_tu.anh_hien_thi,
            url: ExtensionService.urlImg + dichVuChoDuyetRes.result.ve_dien_tu.anh_hien_thi
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.dich_vu.ve_dien_tu.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('dich_vu.ve_dien_tu.anh_hien_thi');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "diemDen")
        .then(res => {
          this.mData.dataForm.dich_vu.ve_dien_tu.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('dich_vu.ve_dien_tu.anh_hien_thi');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('dich_vu.ve_dien_tu.anh_hien_thi');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_go() {
      this.$router.go(-1);
    }
  },
  computed: {
    getStatusName() {
      if (this.mData.dataForm.dich_vu.ready) {
        return "Chờ duyệt";
      } else if (!this.mData.dataForm.dich_vu.duyet.duoc_duyet) {
        return "Từ chối";
      } else if (!this.mData.dataForm.dich_vu.ready) {
        return "Đang soạn thảo";
      } else {
        return "";
      }
    },
  },
}
</script>
